// extracted by mini-css-extract-plugin
export default {"cta":"MH-z","disabled":"NH-z"};